import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {SearchFilter} from '@app/core/services/search/search-filter.interface'

import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {
  TemplateService,
  Template,
  GetTemplatesRequest,
} from '@app/core/services/template/template.service'
import {LoggerService} from '@app/core/services/logger.service'
import {NotificationService} from '@app/core/services/notification.service'
import {ContextService} from '@app/core/services/context.service'

export interface TemplateRequest extends LoadRequest {
  query: string
  sortField: string
  sortAsc: boolean
}

@Injectable()
export class TemplateListService extends GenericListService<Template> {
  filter: SearchFilter = null

  constructor(
    private templateSvc: TemplateService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Template>> {
    // build the service request
    const svcRequest: GetTemplatesRequest = {
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.templateSvc.getTemplates(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Template> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
